export const MODERN_IMAGE_LIST_PRESET = [
  {
    displayedName: 'Серая ванная комната в стиле лофт',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'seraya-vannaya-komnata-v-stile-loft',
    rating: 1002,
    style: 'modern',
  },
  {
    displayedName: 'Светлая ванная в скандинавском стиле со стиральной машинкой',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg'],
    productName: 'svetlaya-vannaya-v-skandinavskom-stile-so-stiralnoy-mashinkoy',
    style: 'modern',
    rating: 1004,
  },
  {
    displayedName: 'Светлая ванная комната с чёрными акцентами',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg', '5.jpg/5.jpg', '6.jpg/6.jpg'],
    productName: 'svetlaya-vannaya-komnata-s-chernymi-akcentami-v-minimalistichnom-stile',
    style: 'modern',
  },
  {
    displayedName: 'Просторная ванная комната с душевой зоной Walk-in',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'prostornaya-vannaya-komnata-s-dushevoy-zonoy-walk-in',
    style: 'modern',
  },
  {
    displayedName: 'Современная ванная комната с черной сантехникой',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'sovremennaya-vannaya-komnata-s-chernoy-santehnikoy',
    style: 'modern',
  },
  {
    displayedName: 'Мягкие оттенки бежевой ванной комнаты',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'myagkie-ottenki-bezhevoy-vannoy-komnaty',
    style: 'modern',
  },
  {
    displayedName: 'Ванная комната с мраморной плиткой',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'vannaya-komnata-s-mramornoy-plitkoy',
    style: 'modern',
  },
  {
    displayedName: 'Скандинавское обустройство ванной комнаты',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'skandinavskoe-obustroystvo-vannoy-komnaty',
    style: 'modern',
  },
  {
    displayedName: 'Городской минимализм в ванной комнате',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'gorodskoy-minimalizm-v-vannoy-komnate',
    style: 'modern',
  },
  {
    displayedName: 'Светло серая ванная комната с необычной плиткой',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'svetlo-seraya-vannaya-komnata-s-neobychnoy-plitkoy',
    style: 'modern',
  },
  {
    displayedName: 'Розовая ванная комната: фото и идеи для интерьера',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'rozovaya-vannaya-komnata',
    style: 'modern',
  },
  {
    displayedName: 'Ванная комната в благородных оттенках мрамора',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'vannaya-komnata-v-blagorodnyh-ottenkah-mramora',
    style: 'modern',
  },
  {
    displayedName: 'Светлая ванная комната с необычными яркими акцентами',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'svetlaya-vannaya-komnata-s-neobychnymi-yarkimi-akcentami',
    style: 'modern',
  },
  {
    displayedName: 'Мраморная ванная',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg', '5.jpg/5.jpg'],
    productName: 'mramornaya-vannaya',
    style: 'modern',
  },
  {
    displayedName: 'Изысканный дизайн ванной комнаты с нежно-розовыми акцентами',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'izyskannyy-dizayn-vannoy-komnaty-s-nezhno-rozovymi-akcentami',
    style: 'modern',
  },
  {
    displayedName: 'Cветло-серая ванная комната в стиле лофт',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg'],
    productName: 'cvetlo-seraya-vannaya-komnata-v-stile-loft',
    style: 'modern',
  },
  {
    displayedName: 'Светлая ванная комната в мраморной плитке',
    mediaMainPhoto: ['1.jpg/1.jpg', '2.jpg/2.jpg', '3.jpg/3.jpg', '4.jpg/4.jpg', '5.jpg/5.jpg', '6.jpg/6.jpg', '7.jpg/7.jpg'],
    productName: 'svetlaya-vannaya-komnata-v-mramornoy-plitke-s-derevyannymi-akcentami',
    style: 'modern',
  },
  {
    displayedName: 'Разнообразные способы хранения в ванной',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    productName: 'raznoobraznye-sposoby-hraneniya-v-vannoy',
    style: 'modern',
  },
];
